export enum LegalEntityFormAction {
  SET_LEGAL_ENTITY = 'SET_LEGAL_ENTITY',
  SET_LOADING_LEGAL_ENTITY = 'SET_LOADING_LEGAL_ENTITY',
  CREATE_LEGAL_ENTITY = 'CREATE_LEGAL_ENTITY',
  UPDATE_LEGAL_ENTITY = 'UPDATE_LEGAL_ENTITY',
}

export const COMPANY_TYPE_OPTION = [
  { value: '1', label: 'PRIVATE_PROFIT' },
  { value: '2', label: 'GOVERNMENT' },
  { value: '3', label: 'SOLE_PROPRIETOR' },
  { value: '4', label: 'NON_PROFIT' },
];

export const VERTICAL_TYPE_OPTION = [
  { value: '1', label: 'PROFESSIONAL' },
  { value: '2', label: 'REAL_ESTATE' },
  { value: '3', label: 'HEALTHCARE' },
  { value: '4', label: 'HUMAN_RESOURCES' },
  { value: '5', label: 'ENERGY' },
  { value: '6', label: 'ENTERTAINMENT' },
  { value: '7', label: 'RETAIL' },
  { value: '8', label: 'TRANSPORTATION' },
  { value: '9', label: 'AGRICULTURE' },
  { value: '10', label: 'INSURANCE' },
  { value: '11', label: 'POSTAL' },
  { value: '12', label: 'EDUCATION' },
  { value: '13', label: 'HOSPITALITY' },
  { value: '14', label: 'FINANCIAL' },
  { value: '15', label: 'POLITICAL' },
  { value: '16', label: 'GAMBLING' },
  { value: '17', label: 'LEGAL' },
  { value: '18', label: 'CONSTRUCTION' },
  { value: '19', label: 'NGO' },
  { value: '20', label: 'MANUFACTURING' },
  { value: '21', label: 'GOVERNMENT' },
  { value: '22', label: 'TECHNOLOGY' },
  { value: '23', label: 'COMMUNICATION' },
];
